import { PromotionBanner } from "@clipboard-health/ui-components";
import { formatDollarsAsUsd } from "@src/appV2/lib/Money/utils/currency";

export interface FailedPayoutBannerProps {
  payoutAmount: number;
  onClick: () => void;
}

export function FailedPayoutBanner(props: FailedPayoutBannerProps) {
  const { payoutAmount, onClick } = props;

  return (
    <PromotionBanner
      title={`We couldn't send your ${formatDollarsAsUsd(payoutAmount)} payout`}
      subtitle="Don’t worry — this is usually easy to fix."
      icon="dollar-error-colored"
      borderVariant="none"
      backgroundColor={(theme) => theme.palette.intent!.error.gradient!}
      titleColor={(theme) => theme.palette.intent!.error.text}
      ctaButtonText="Review and fix issue"
      ctaButtonVariant="outlined"
      sx={{ height: "100%" }}
      onClick={onClick}
    />
  );
}
